import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient  from '../ApiClient';
import { MessageQueryKeys } from './message-query-key';
import { apiRoutes } from '../ApiRoutes';

const createSendFn = async (newMessage: {}) => {
  const response = await apiClient.post(apiRoutes.SendMessages, newMessage);
  return response.data;
};

// https://tanstack.com/query/latest/docs/react/guides/optimistic-updates
export function useCreateMesage() {
  const queryClient = useQueryClient();
//   const { toast } = useToast();

  return useMutation({
    mutationFn: createSendFn,
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: MessageQueryKeys.all });
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({queryKey: MessageQueryKeys.all });
    },
    onError: (err, newUser, context?: any) => {
      // tinyAlert('error', err.message);
      queryClient.setQueryData(MessageQueryKeys.all, context.previousUsers);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: MessageQueryKeys.all });
    },
  });
}
